import MarkdownRenderer from './MarkdownRenderer';
import type { LighthouseAudit } from '@/app/PageSpeed/api/types/analysisApiTypes';

type Props = { audit: LighthouseAudit };

const ScreenshotAuditRenderer = ({ audit }: Props) => {
  if (!audit.details || !audit.details.headings || !audit.details.items) {
    return <div>No Screenshot data available</div>;
  }
  return (
    <div>
      <MarkdownRenderer content={audit.description} />
      {audit.details.items.map((item: any, idx: number) => (
        <img key={idx} src={item.data} alt={`Screenshot ${idx}`} />
      ))}
    </div>
  );
};

export default ScreenshotAuditRenderer;
